import { Http } from '../helpers'

export const TechnicainService = {
  async search(params) {
    return await Http.get('/technicians', { params: params })
  },
  async autocomplete() {
    return await Http.get('/technicians/autocomplete')
  },
  async all() {
    return await Http.get('/technicians/all')
  },
  async view(id) {
    return await Http.get('/technicians/' + id)
  },
  async delete(id) {
    return await Http.delete('/technicians/' + id)
  },
  async create(params) {
    return await Http.post('/technicians', params)
  },
  async update(id, params) {
    return await Http.put('/technicians/' + id, params)
  },
  async getStatus() {
    return await Http.get('/technicians/status')
  },
}
